<template>
  <div id="balance">
    <ul v-if="loginState && !Number(webMode)">
      <li>
        希望幣<span class="cr">{{
          userInfo.D | toThousandFilter
        }}</span>
      </li>
      <li>
        金幣<span class="cy">{{
          userInfo.G | toThousandFilter
        }}</span>
      </li>
      <li>
        銀幣<span class="cg">{{
          userInfo.S | toThousandFilter
        }}</span>
      </li>
      <li>
        銅幣<span class="c4">{{
          userInfo.C | toThousandFilter
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "balance",
  computed: {
    ...mapGetters({
      webMode: "webMode",
      loginState: "loginState",
    }),
    ...mapState({
      userInfo: (state) => state.member.userInfo,
    }),
  },
};
</script>

<style scoped>
@import "~@/assets/css/balance.css";
</style>
